/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Lot_History_Col_ReasonInputs */

const vi_product_lot_history_col_reason = /** @type {(inputs: Product_Lot_History_Col_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lý do`)
};

/**

* @param {Product_Lot_History_Col_ReasonInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_lot_history_col_reason = /** @type {((inputs?: Product_Lot_History_Col_ReasonInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Lot_History_Col_ReasonInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_lot_history_col_reason(inputs)
});